<template>
  <SelectButton
    :model-value="theme.theme"
    :options="options"
    option-label="name"
    option-value="value"
    :allow-empty="false"
    :aria-label="label"
    data-key="value"
    data-theme-setting
    @update:model-value="theme.choose"
  />
</template>

<script setup>
import SelectButton from 'primevue/selectbutton';
import { computed } from 'vue';

import { useShellWords } from './shellWords.js';
import { useThemeStore } from './themeStore.js';

// The Theme setting: OS, Light or Dark. The same control on a phone and on a
// desktop. What choosing one does — where it is saved — is the theme store's.

defineProps({
    // The setting's name, as the Settings page shows it. It names the control
    // for a screen reader.
    label: { type: String, default: '' }
});

const theme = useThemeStore();
const word = useShellWords();

const options = computed(() => [
    { value: 'system', name: word('shell.settings.themeSystem') },
    { value: 'light', name: word('shell.settings.themeLight') },
    { value: 'dark', name: word('shell.settings.themeDark') }
]);
</script>
